import controlDate from './index.js';

const SET_LOADING = (state, loading) => {
  state.loading = loading;
};

const SET_PROVIDERS = (state, providers) => {
  state.cmsProviders = providers;
};

const SET_SEARCH = (state, search) => {
  state.search = search;
}

const SET_TOTAL_PAGES = (state, totalPages) => {
  state.totalPages = totalPages;
}

const SET_CURRENT_PAGE = (state, currentPage) => {
  state.currentPage= currentPage;
}

const SET_TOTAL_PROVIDERS = (state, totalProducts) => {
  state.totalProducts = totalProducts
}

const SET_PUBLISHED_FILTER = (state, value) => {
  state.publishedFilter = value;
}

const SET_PORTAUS_COMPANY_IDS_FILTER = (state, value) => {
  state.portausCompanyIdsFilter = value;
}

const SET_HAS_LOGO_FILTER = (state, value) => {
  state.hasLogoFilter = value;
}

const SET_HAS_MAIN_IMAGE_FILTER = (state, value) => {
  state.hasMainImageFilter = value;
}

const INVALIDATE = (state) => {
  state.outDated= true;
}


export default {
  SET_LOADING,
  SET_PROVIDERS,
  SET_SEARCH,
  SET_TOTAL_PROVIDERS,
  SET_PUBLISHED_FILTER,
  SET_PORTAUS_COMPANY_IDS_FILTER,
  SET_HAS_LOGO_FILTER,
  SET_HAS_MAIN_IMAGE_FILTER,
  SET_CURRENT_PAGE,
  SET_TOTAL_PAGES,
  INVALIDATE
};
